<template>
  <modal class="modal cloudapp-modal narrow" id="login-modal" :hide-footer="true">
    <template #modal-header>
      <img
        src="@img/cloudapp.png"
        width="180"
        height="41"
        class="logo"
        alt="CloudApp Logo"
      />
    </template>

    <div>
      <ul class="errors text-danger"></ul>
      <div class="mb-4">
        <h1 class="h4 text-center">Welcome back</h1>
      </div>
      <a
        href="#"
        class="btn d-flex justify-content-center align-items-center google-login-button btn-block btn-auth"
        @click="authorizeGoogleOauth"
      >
        <img
          width="18"
          height="18"
          src="@img/icon-google.svg"
          class="mr-2"
          alt="Google Logo"
        />
        <span>Sign in with Google</span>
      </a>

      <a
        :href="appleIdUrl"
        class="btn d-flex justify-content-center align-items-center google-login-button btn-block btn-auth"
      >
        <img
          width="18"
          height="18"
          src="@img/apple_logo.svg"
          class="mr-2"
          alt="Apple Logo"
        />
        <span>Sign in with Apple</span>
      </a>

      
      <a 
        v-if="showSlackButton" 
        :href="slackIdUrl"
        class="btn d-flex justify-content-center align-items-center google-login-button btn-block btn-auth"
      >
        <img
          width="18"
          height="18"
          src="@img/slack_logo.svg"
          class="mr-2"
          alt="Slack Logo"
        >
        <span>Sign in with Slack</span>
      </a>
     

      <p class="my-4 text-center divider-label">
        <small class="text-muted">or sign in with email</small>
      </p>

      <form data-type="json" autocomplete="false" action="/api/v4/login" accept-charset="UTF-8" data-remote="true" method="post">
        <div class="form-group">
          <label for="email">Email</label>
          <input type="email" name="email" id="email" required="required" class="form-control" autocomplete="off" v-model="email" @keydown.stop>
        </div>
        <div class="form-group">
          <div class="d-flex justify-content-between text-sm">
            <label for="password">Password</label>
            <a href="/forgot_password">Forgot password?</a>
          </div>
          <input type="password" name="password" id="password" required="required" autocomplete="off" class="form-control" @keydown.stop>
          <input value="web:viewer" type="hidden" name="source" id="source">
          <input :value="returnTo" type="hidden" name="redirect_to" id="redirect_to">
        </div>
        <div class="text-center">
          <input type="submit" name="commit" value="Sign in" data-disable-with="Log in" class="btn-primary btn btn-block identifyUser create-account">
        </div>
      </form>
    </div>
    <div id="no-account">
      <nav aria-label="Secondary navigation">
        <ul class="list-unstyled text-sm text-center">
          <li><a href="/sso/new?utm_campaign=login_modal&utm_source=viewer">Sign in with SSO</a></li>
          <li>New to CloudApp? <a href="#" @click="trackAndOpenLogin" data-testid="signup-link">Sign up for free</a></li>
        </ul>
      </nav>
    </div>
  </modal>
</template>

<script>
import Modal from "@cmp/modal.vue";
import track from '@/src/tracking';
import authorizeGoogleOauth from '@/src/google_oauth';
import featureKey from "../feature_key.macro";
import { modalsUser } from "@/src/observable";
import { mapState } from 'vuex';


export default {
  components: { Modal },
  props: {
    returnTo: String
  },
  methods: {
    trackAndOpenLogin: function(){
      track('login_to_signup_viewer');
      this.$bvModal.hide('login-modal');
      this.$bvModal.show('signup-modal');
    },
    authorizeGoogleOauth: authorizeGoogleOauth
  },
  computed: {
    ...mapState({
      showSlackSignButton: state => state.features?.[featureKey("web-show-slack-sign-button")],
    }),
    email: {
      set: function(val){ modalsUser.email = val },
      get: function(){ return modalsUser.email }
    },
    showSlackButton : function(){
      return this.showSlackSignButton;
    },
    appleIdUrl: () => `/auth/apple?web=true&return_to=${window.location.href}`,
    slackIdUrl: () => `/auth/slack?web=true&return_to=${window.location.href}`
  }
}
</script>

<style lang="scss">
  @import "application.scss";

  #login-modal___BV_modal_outer_ {
    .modal-content {
      overflow: hidden;
      overflow-y: auto;
      border-radius: 10px;
      border: 0 none;
    }

    .modal-dialog {
      max-width: 380px;
      
    }

    .modal-header {
      display: flex;
      align-items: center;
      justify-content: center;
      border: 0 none;
      padding-bottom: 0;
      

      .logo {
        margin-top: 1rem;
      }
    }

    .modal-body {
      padding: 1rem;

      @media screen and (min-width: 400px) {
        padding: 1rem 4rem;
      }

      form {
        label {
          font-size: 12px;
          font-weight: 600;
        }
      }

      #no-account {
        border-top: 1px solid #dee2e6;
        margin-top: 1.25rem;
        padding: 1.25rem;
        text-align: center;
      }
    }
  }
  .btn-auth {
    border: 1px solid #d8d8d8;
    border-radius: 8px;
    padding: .9rem 1.5rem .9rem !important;
    font-size: .9rem !important;
    font-weight: 600;
  }
  .btn-auth:hover {
    background-color: #eee;
  }
</style>
